export const lightTheme = {
  // light default colors
  // primary: '#6699cc',

  focus: '#0000000f',
  active: '#00000033',
  // primary colors
  primary30: '#004a99',
  primary40: '#0063cc',
  primary50: '#007bff',
  primary60: '#3396ff',
  primary70: '#66b0ff',
  'primary-focus': '#00000033',

  // secondary colors
  secondary30: '#994f00',
  secondary40: '#cc6900',
  secondary50: '#ff8400',
  secondary60: '#ff9c33',
  secondary70: '#ffb566',

  // danger colors
  danger50: '#eb5545',

  // apple light colors
  blue: '#007AFF',
  green: '#34C759',
  indigo: '#5856D6',
  orange: '#FF9500',
  pink: '#FF2D55',
  purple: '#AF52DE',
  red: '#FF3B30',
  teal: '#5AC8FA',
  yellow: '#FFCC00',
  gray1: '#8E8E93',
  gray2: '#AEAEB2',
  gray3: '#C7C7CC',
  gray4: '#D1D1D6',
  gray5: '#E5E5EA',
  gray6: '#F2F2F7',

  // global vars
  'border-color': '#000',

  bar: '#eeeeee',
  bartext: '#111111',
  body: '#FAFBFC',
  text: '#202020',
  inverse: '#212121',
  scrollbarbgcolor: '#f5f5f5',
  scrollbarborder: '2px solid #d4d1d1',
  scrollbartrackbgcolor: 'rgb(180 180 180)',
  bottomnavbgcolor: '#eeeeee',
  textsecondary: 'rgba(0, 0, 0, 0.54)',
  bottomborder: 'black 1px solid',
  barshadow:
    '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  logoimg: 'url(/imgs/assets/white-logo-512.svg)',
  gitimg: 'url(/imgs/assets/devops/github-logo-black.svg)',
  imgborder: 'black 1px solid',
  menubackground: '#f1f1f1',
  menutextcolor: '#545454',
  globalbackground: '#ffffff',
  npmbackground: '#ffffff',
  gitbackground: '#ffffff',
  npmopacity: '0.6',
  gitopacity: '0.6',
  gitshadow:
    'rgb(22 21 22) 0px 0px 5px 0px, rgb(22 21 22) 0px 0px 0px 0px, rgb(22 21 22) 0px 0px 0px 0px',
  gitshadowhover:
    'rgb(22 21 22) 0px 0px 10px 0px, rgb(22 21 22) 0px 0px 0px 0px, rgb(22 21 22) 0px 0px 0px 0px',
  gitborder: '1px solid rgb(0 0 0 / 49%)',
  gitborderhover: '1px solid rgb(0 0 0 / 69%)',
  dbcbackground: '#f0f0f0',
  dbcshadow:
    'rgb(13 95 19) 0px 0px 15px 0px, rgb(26 95 13) 0px 0px 0px 0px, rgb(14 95 13) 0px 0px 0px 0px',
  dbcborder: '1px solid rgb(0 204 35 / 49%)',
  dbcshadowhover:
    'rgb(97 142 100) 0px 0px 15px 0px, rgb(131 160 126) 0px 0px 0px 0px, rgb(128 156 128) 0px 0px 0px 0px',
  dbcborderhover: '1px solid rgb(0 204 35 / 32%)',
  tagcolor: '#100e8a',
  buttonborder: '#828282 1px solid',
  sidenavbg: '#FFFFFF',
  sidenavhover: '#F5F6F6',
  iconcolor: '#767576',
  borderstyle: '1px solid #c0c1c2',
  divider: '#fff',
  cardbg: '#fff',
  cardshadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  textfieldcolor: '#ffffff',
  textfieldtextcolor: '#232323',
  textfieldoutlinecolor: '#828282',
  textfieldoutlinecolorhover: '#666666',
  lighttextfieldcolor: '#ffffff',
  lighttextfieldtextcolor: '#232323',
  lighttextfieldoutlinecolor: '#828282',
  lighttextfieldoutlinecolorhover: '#666666',
  buttonbgcolor: '#b53f3f',
  buttonbgcolorhover: '#c15353',
  buttontextcolor: '#ffffff',
  disabledtextcolor: 'rgba(0, 0, 0, 0.26)'
}
export const darkTheme = {
  // dark default colors
  // primary: '#0A84FF',
  // primary: '#6699cc',
  // primary: '#448bd2',

  // primary: '#1c4075',
  // secondary: '#FF9F0A',
  // secondary: '#666699',
  focus: '#ffffff0f',
  active: '#ffffff33',

  // primary colors
  primary30: '#0056b3',
  primary40: '#006fe6',
  primary50: '#1a88ff',
  primary60: '#4da3ff',
  primary70: '#80bdff',
  'primary-focus': '#ffffff33',

  // secondary colors
  secondary30: '#b35c00',
  secondary40: '#e67700',
  secondary50: '#ff901a',
  secondary60: '#ffa94d',
  secondary70: '#ffc180',

  // danger colors
  danger50: '#ee6c5d',

  // apple dark colors
  blue: '#0A84FF',
  green: '#30D158',
  indigo: '#5E5CE6',
  orange: '#FF9F0A',
  pink: '#FF375F',
  purple: '#BF5AF2',
  red: '#FF453A',
  teal: '#64D2FF',
  yellow: '#FFD60A',
  gray1: '#8E8E93',
  gray2: '#636366',
  gray3: '#48484A',
  gray4: '#3A3A3C',
  gray5: '#2C2C2E',
  gray6: '#1C1C1E',

  // global vars
  'border-color': '#fff',

  bar: '#111111',
  bartext: '#eeeeee',
  body: '#000000',
  text: '#FAFBFC',
  inverse: '#212121',
  scrollbarbgcolor: '#111',
  scrollbarborder: '2px solid #202020',
  scrollbartrackbgcolor: 'rgb(60 60 60)',
  bottomnavbgcolor: '#111111',
  textsecondary: 'rgba(225,225,225,0.54)',
  bottomborder: '#FAFBFC 1px solid',
  barshadow:
    '0px 1px 1px -1px rgb(255 255 255 / 20%), 0px 4px 5px 0px rgb(255 255 255 / 14%), 0px 1px 2px 0px rgb(255 255 255 / 12%)',
  logoimg: 'url(/imgs/assets/black-logo-512.svg)',
  gitimg: 'url(/imgs/assets/devops/github-logo-white.svg)',
  imgborder: 'white 1px solid',
  menubackground: '#0e0e0e',
  menutextcolor: '#ababab',
  globalbackground: 'rgb(0 0 0)',
  npmbackground: 'rgb(0 0 0)',
  gitbackground: 'rgb(0 0 0)',
  npmopacity: '0.5',
  gitopacity: '0.5',
  gitshadow:
    'rgb(93 88 88) 0px 0px 10px 0px, rgb(93 88 88) 0px 0px 0px 0px, rgb(93 88 88) 0px 0px 0px 0px',
  gitshadowhover:
    'rgb(93 88 88) 0px 0px 15px 0px, rgb(93 88 88) 0px 0px 0px 0px, rgb(93 88 88) 0px 0px 0px 0px;',
  gitborder: '1px solid rgb(255 255 255 / 49%)',
  gitborderhover: '1px solid rgb(255 255 255 / 69%)',
  dbcbackground: '#0f0f0f',
  dbcshadow:
    'rgb(13 95 19) 0px 0px 15px 0px, rgb(26 95 13) 0px 0px 0px 0px, rgb(14 95 13) 0px 0px 0px 0px',
  dbcborder: '1px solid rgb(0 204 35 / 49%)',
  dbcshadowhover:
    'rgb(97 142 100) 0px 0px 15px 0px, rgb(131 160 126) 0px 0px 0px 0px, rgb(128 156 128) 0px 0px 0px 0px',
  dbcborderhover: '1px solid rgb(0 204 35 / 32%)',
  tagcolor: '#fbff00',
  buttonborder: '#d8d8d8 1px solid',
  sidenavbg: '#2B2B2B',
  sidenavhover: '#111111',
  iconcolor: '#E5E5E5',
  borderstyle: '1px solid #3f3e3d',
  divider: '#000',
  cardbg: '#161616',
  cardshadow:
    '0px 2px 1px -1px rgb(236 236 236 / 20%), 0px 1px 1px 0px rgb(220 220 220 / 14%), 0px 1px 3px 0px rgb(222 222 222 / 12%)',
  textfieldcolor: '#ffffff',
  textfieldtextcolor: '#E5E5E5',
  textfieldoutlinecolor: '#d8d8d8',
  textfieldoutlinecolorhover: '#939393',
  lighttextfieldcolor: '#ffffff',
  lighttextfieldtextcolor: '#232323',
  lighttextfieldoutlinecolor: '#828282',
  lighttextfieldoutlinecolorhover: '#666666',
  buttonbgcolor: '#b53f3f',
  buttonbgcolorhover: '#c15353',
  buttontextcolor: '#ffffff',
  disabledtextcolor: 'rgba(255, 255, 255, 0.26)'
}
